import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { fetchSparksWallet } from '@/services/sparks';
import { supabase } from '@/integrations/supabase/client';

export function useSparksWallet() {
  const { user } = useAuth();
  const queryClient = useQueryClient();

  useEffect(() => {
    if (!user?.id) return;
    const channel = supabase
      .channel(`sparks-wallet-${user.id}`)
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'sparks_wallet',
          filter: `user_id=eq.${user.id}`,
        },
        () => {
          queryClient.invalidateQueries({ queryKey: ['sparks-wallet', user.id] });
        }
      )
      .subscribe();
    return () => { supabase.removeChannel(channel); };
  }, [user?.id, queryClient]);

  return useQuery({
    queryKey: ['sparks-wallet', user?.id],
    queryFn: () => fetchSparksWallet(user!.id),
    enabled: !!user?.id,
    staleTime: 5 * 60 * 1000,
  });
}
